import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    continueOnboarding: 'Continue onboarding',
    createStripeAccount: 'Create a Stripe account',
    noStripeAccount: 'Your company does not have a Stripe account associated.',
    onboardingFinished: 'Your Stripe account is ready to receive payments.',
    onboardingNotFinished: 'You have not finished the onboarding process.',
  },
  fr: {
    continueOnboarding: 'Continuer l’onboarding',
    createStripeAccount: 'Créer un compte Stripe',
    noStripeAccount: 'Votre entreprise n’a pas de compte Stripe associée.',
    onboardingFinished:
      'Votre compte Stripe est prêt à recevoir des paiements.',
    onboardingNotFinished: 'Vous n’avez pas terminé le processus d’onboarding.',
  },
});

export default locales;
